import './S26Carousel.css';

import { useState } from 'react';
import { Swiper, SwiperSlide } from 'swiper/react';
import { Pagination, Navigation, Autoplay } from 'swiper/modules';
import { useNavigate } from 'react-router-dom';

import galaxyS26UltraImage from '../../assets/samsungStore/GalaxyS26/S26ultra/GalaxyS26Ultra.png';
import galaxyS26Image from '../../assets/samsungStore/GalaxyS26/S26/s26.png';

import 'swiper/css';
import 'swiper/css/pagination';
import 'swiper/css/navigation';

const slides = [
  {
    key: 's26-ultra',
    sectionClassName: 's26-ultra-slide',
    intro: 'Introducing the New',
    title: 'Galaxy S26 Ultra',
    price: 'Starts at Rs. 1,39,999',
    emi: 'or No Cost EMI at Rs. 5,834 p.m.',
    image: galaxyS26UltraImage,
    alt: 'Samsung Galaxy S26 Ultra',
    detailId: 5,
    showViewDetails: true,
  },
  {
    key: 's26',
    sectionClassName: 's26-base-slide',
    intro: 'Introducing the New',
    title: 'Galaxy S26',
    price: 'Starts at Rs. 87,999',
    emi: 'or No Cost EMI at Rs. 3,667 p.m.',
    image: galaxyS26Image,
    alt: 'Samsung Galaxy S26',
    detailId: 3,
    showViewDetails: true,
  },
];

const S26Carousel = () => {
  const navigate = useNavigate();
  const [swiperInstance, setSwiperInstance] = useState(null);

  const pauseAutoplay = () => {
    swiperInstance?.autoplay?.stop();
  };

  const resumeAutoplay = () => {
    swiperInstance?.autoplay?.start();
  };

  const handleViewDetails = (detailId) => {
    navigate(
      `/applestore/iphone-products-list/iphone-detail-page/galaxySSeries/${detailId}`
    );
  };

  return (
    <div className="s26-carousel-wrapper">
      <Swiper
        modules={[Pagination, Navigation, Autoplay]}
        navigation
        pagination={{ type: 'progressbar', clickable: true }}
        slidesPerView={1}
        spaceBetween={0}
        autoplay={{ delay: 3500, disableOnInteraction: false }}
        style={{ padding: '0 0 3% 0', borderRadius: '40px' }}
        onSwiper={(swiper) => setSwiperInstance(swiper)}
      >
        {slides.map((slide) => (
          <SwiperSlide key={slide.key}>
            <section className={`s26-slide ${slide.sectionClassName}`}>
              <div className="s26-image-pane">
                <img src={slide.image} alt={slide.alt} className="s26-phone-image" />
              </div>

              <div className="s26-content-pane">
                <p className="s26-intro">{slide.intro}</p>
                <h1 className="s26-title">{slide.title}</h1>
                <h2 className="s26-price">{slide.price}</h2>
                <p className="s26-emi">{slide.emi}</p>

                {slide.showViewDetails && (
                  <button
                    className="s26-view-details-btn"
                    onClick={() => handleViewDetails(slide.detailId)}
                    onMouseEnter={pauseAutoplay}
                    onMouseLeave={resumeAutoplay}
                  >
                    View Detail
                  </button>
                )}

                <p className="s26-terms">
                  *Terms and Conditions Apply.
                  <br />
                  The EMI amount may differ from person to person.
                  <br />
                  EMI offers are subject to changes without prior notice.
                </p>
              </div>
            </section>
          </SwiperSlide>
        ))}
      </Swiper>
    </div>
  );
};

export default S26Carousel;
